module.exports = __webpack_public_path__ + "img/email.15fc14e0.png";